var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:['icon', `icon-${_vm.name}`],style:(_vm.iconStyle),attrs:{"width":_vm.iconWidth,"height":_vm.iconHeight,"aria-hidden":"true","focusable":"false"}},[_c('use',{attrs:{"href":`#${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }